import { ReactNode } from 'react';

import { SegmentedControl as RadixSegmentedControl } from '@radix-ui/themes';
import cn from 'classnames';

import styles from './SegmentedControl.module.less';
import { SegmentedControlProps } from './SegmentedControl.types';

export type SegmentedControlRootProps = Omit<SegmentedControlProps, 'items'> & {
  children: ReactNode;
  style?: React.CSSProperties;
};

export type SegmentedControlItemProps = {
  value: string;
  className?: string;
  children?: ReactNode;
};

function Root({
  variant = 'surface',
  size = '1',
  onChange,
  value,
  className,
  children,
  ...props
}: SegmentedControlRootProps) {
  return (
    <RadixSegmentedControl.Root
      {...props}
      onValueChange={onChange}
      variant={variant}
      size={size}
      value={value}
      className={cn(styles.segmentedControl, 'rounded-4', className)}
    >
      {children}
    </RadixSegmentedControl.Root>
  );
}

function Item({ value, className, children }: SegmentedControlItemProps) {
  return (
    <RadixSegmentedControl.Item
      value={value}
      className={cn('rounded-4', className)}
    >
      {children}
    </RadixSegmentedControl.Item>
  );
}

export function SegmentedControl({ items, ...props }: SegmentedControlProps) {
  return (
    <Root {...props}>
      {items.map((item) => (
        <Item key={item.value} value={item.value}>
          {item.label}
        </Item>
      ))}
    </Root>
  );
}

SegmentedControl.Root = Root;
SegmentedControl.Item = Item;
